import {
	ErrorModal,
	HelmetDexteel,
	MesfModal,
	dxtToLocalServerTime,
} from "@dexteel/mesf-core";
import { Button, Grid2 } from "@mui/material";
import { useState } from "react";
import { PassChangesHistoryTable } from "./PassChangesHistory";
import { useFormCarrier } from "../build/CarrierBuildFormPage";

export const PassChangeModal = ({
	open,
	onHide,
	setNotificationMessage,
	carrier,
	initialTimestamp,
	refetch = () => {},
}: {
	open: boolean;
	onHide: (updated?: boolean) => void;
	setNotificationMessage: (message: string) => void;
	carrier: { partId: number; carrierInstanceId: number };
	initialTimestamp?: Date;
	refetch?: () => void;
}) => {
	const [error, setError] = useState("");

	const { data, isLoading } = useFormCarrier(
		carrier?.partId ?? 0,
		carrier?.carrierInstanceId,
		(error) => setError(error.message),
		open,
	);

	const carrierForm = data?.carrierData ?? null;
	const rollsPasses = data?.passesData ?? {
		top: [],
		bottom: [],
	};

	const handleClose = () => {
		onHide();
	};

	return (
		<>
			{open && (
				<HelmetDexteel title={`${carrierForm?.CarrierName} - Pass Change`} />
			)}
			<MesfModal
				title="PASS HISTORY"
				subtitle={`Carrier Installed: ${dxtToLocalServerTime(
					carrierForm?.InstalledAt,
					"MM/dd/yy HH:mm:ss",
				)} | Uninstalled: ${dxtToLocalServerTime(
					carrierForm?.UninstalledAt,
					"MM/dd/yy HH:mm:ss",
				)}`}
				open={open}
				id="pass-change-modal"
				maxWidth="md"
				handleClose={handleClose}
			>
				<MesfModal.Content
					style={{ padding: "15px 30px", overflow: "scroll" }}
					dividers
				>
					<Grid2 container spacing={2}>
						<PassChangesHistoryTable
							open={open}
							carrier={carrier}
							rollsPasses={rollsPasses}
							carrierForm={carrierForm}
							initialTimestamp={initialTimestamp}
							setNotificationMessage={setNotificationMessage}
							setError={setError}
							onSaved={() => {
								refetch();
							}}
						/>
					</Grid2>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
					<Grid2 container spacing={2} justifyContent="flex-end">
						<Grid2 size={{ md: 3, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={handleClose}
								data-test-id="close-button"
							>
								Close
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
